/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  promotion:{
    name:'',
    id:'',
    type:'',
    typebonus:'',
    maxbonus:'',
    mindeposit:'',
    maxdeposit:'',
    maxwithdraw:'',
    starttime:'',
    endtime:'',
    status:false,
    show:false,
    order:0,
    createdate:'',
    numday:0,
    maxreceive:0,
    turn:0,
    percent:0,
    withdrawtype:'',
    turntype:'',
    image:'',
    setbonus:[],
    
  },
  promotions: [],
  popup:false,
}
